import {
  CustomerPostRequestBody,
  QuoteGetResponse,
  ContactInfoGetResponse,
  InsuredLocationsSearchResponse,
} from '@lio/api-types';
import { ArrayItem, KeyValueOptions } from '@utils/commonTypes';

export type BusinessAddress = {
  id?: string;
  street1: string;
  street2?: string;
  city: string;
  state: string;
  zipCode: string;
};
export type Customer = {
  id: string;
  mdmCustomerId?: string;
  isDuplicateGoldenRecord?: boolean;
  name: string;
  businessType: CustomerPostRequestBody['businessType'];
  createdAt?: Date | string;
  updatedAt?: Date | string;
  deletedAt?: Date | string | null;
  deletedByUserId?: string | null;
  city: string;
  state: string;
  businessAddress?: BusinessAddress;
  jurisdiction?: {
    id?: string;
    abbreviation: string;
  };
  addresses?: ContactInfoGetResponse['addresses'];
};

export type AddressResponse = ArrayItem<ContactInfoGetResponse['addresses']>;

export type BusinessType = CustomerPostRequestBody['businessType'];
export enum AddressType {
  Billing = 'Billing',
  Business = 'Business',
  Mailing = 'Mailing',
}
export enum AddressValidationStatus {
  ExactMatch = 'exact-match',
  NoMatch = 'no-match',
  MultipleMatch = 'multiple-match',
  PartialMatch = 'partial-match',
}
export type QuoteLocations = ArrayItem<QuoteGetResponse['quoteLocations']>;
export type QuoteLocationAddress = QuoteLocations['insuredLocation']['address'];
export type LocationStatus = QuoteLocations['insuredLocation']['status'];

export type InsuredLocationItem = ArrayItem<InsuredLocationsSearchResponse['items']>;
export type InsuredLocationAddress = InsuredLocationItem['address'];

export const InsuredLocationStatus = {
  Invalid: 'Invalid' as LocationStatus,
  AutoApproved: 'AutoApproved' as LocationStatus,
  Approved: 'Approved' as LocationStatus,
};

export const businessTypeItems: KeyValueOptions<string, BusinessType>[] = [
  { key: 'individual', value: 'Individual', label: 'Individual' },
  { key: 'corporation', value: 'Corporation', label: 'Corporation' },
  { key: 'jointVenture', value: 'JointVenture', label: 'Joint Venture' },
  { key: 'llc', value: 'LLC', label: 'LLC' },
  {
    key: 'notForProfitOrg',
    value: 'NotForProfitOrg',
    label: 'Nonprofit',
  },
  { key: 'partnership', value: 'Partnership', label: 'Partnership' },
  { key: 'sCorp', value: 'SCorp', label: 'S Corporation' },
  { key: 'trust', value: 'Trust', label: 'Trust' },
];
